module.exports = __webpack_public_path__ + "img/yeosu_detail.fe36c783.jpg";